import React from "react";

import { Layout, StubBox } from "../../components";
import { Center } from "../../components/ui";

import styles from "./index.module.css";

const CreateVideoPage = () => {
  return (
    <Layout>
      <Center>
        <div className={styles.container}>
          <h1 className={styles.title}>Создать видео</h1>
          <StubBox message="Страница временно недоступна" />
        </div>
      </Center>
    </Layout>
  );
};

export default CreateVideoPage;
